import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useAuthContext } from "../../../hooks/agencyAuthHook";
import toast from "react-hot-toast";
import VoucherColorsHook from "../../../hooks/VoucherColorsHook";
import { ColorPicker } from "@wellbees/color-picker-input";
import shiraka_dummy_logo from "../../../assets/images/shirka_logo.jpg";
import ProfileHook from '../../../hooks/ProfileHook';
import InstructionsHook from '../../../hooks/InstructionsHook';

// Mock data for preview
const previewMembers = [
  {
    name: "Ali",
    ppNo: "IU7868863",
    dob: "01-05-1980",
    age_group: "Adult",
    visa_number: "VS67YO4",
    visa_issue_date: "04-02-2025",
    mofa_date: "16-06-2025",
  },
  {
    name: "Saima Ali",
    ppNo: "IY7358762",
    dob: "28-08-1982",
    age_group: "Adult",
    visa_number: "VE69BO9",
    visa_issue_date: "17-02-2025",
    mofa_date: "16-06-2025",
  },
  {
    name: "Ahmed Ali",
    ppNo: "BT7358762",
    dob: "12-11-2017",
    age_group: "Child",
    visa_number: "TY64X20",
    visa_issue_date: "17-02-2025",
    mofa_date: "16-06-2025",
  },
  {
    name: "Nadia",
    ppNo: "AO0253758",
    dob: "11-04-2024",
    age_group: "Infant",
    visa_number: "",
    visa_issue_date: "",
    mofa_date: "",
  },
];

// Mock accommodation data
const previewAccommodation = [
  {
    hotel_city: "Makkah",
    hotel_name: "Royal Makkah Hotel",
    check_in_date: "01-01-2025",
    check_out_date: "05-01-2025",
    hotel_duration: "4"
  },
  {
    hotel_city: "Madinah",
    hotel_name: "Madinah Hilton",
    check_in_date: "05-01-2025",
    check_out_date: "10-01-2025",
    hotel_duration: "5"
  }
];

export default function VoucherColors() {
  const { loading,getVoucherColors } = VoucherColorsHook();
  const { getAgencyProfile } = ProfileHook();
  const { getInstructions } = InstructionsHook();

  const { agency } = useAuthContext();
  const apiUrl = process.env.REACT_APP_API_URL;
  const vouchercolors = useSelector(
    (state) => state.vouchercolors.vouchercolors
  );
  const profile = useSelector((state) => state.profile?.profile);
  const instructions = useSelector((state) => state.instructions.instructions);

  const [colors, setColors] = useState({
    table_bg_color: "#FFFFFF",
    thead_bg_color: "#F5F5F5",
    tbody_bg_color: "#FFFFFF",
    header_color: "#000000",
  });

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    document.title = "Voucher Colors";
    getVoucherColors();
    getAgencyProfile()
    getInstructions()
  }, []);

  useEffect(() => {
    if (vouchercolors) {
      setColors({
        table_bg_color: vouchercolors.table_bg_color || "#FFFFFF",
        thead_bg_color: vouchercolors.thead_bg_color || "#F5F5F5",
        tbody_bg_color: vouchercolors.tbody_bg_color || "#FFFFFF",
        header_color: vouchercolors.header_color || "#000000",
      });
    }
  }, [vouchercolors]);

  const handleColorChange = (key, value) => {
    setColors((prev) => ({ ...prev, [key]: value }));
  };

  const addVoucherColors = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await fetch(
        `${apiUrl}/api/agencies/voucher_colors/add`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${agency.token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ data: colors }),
        }
      );
      const json = await response.json();

      if (response.ok) {
        toast.success(json.message || "Colors saved successfully!");
        getVoucherColors();
      } else {
        throw new Error(json.message || "Failed to save voucher colors.");
      }
    } catch (error) {
      toast.error(error.message || "Failed to save colors.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="row px-1 mt-0 pt-0">
      <div className="col-md-4 p-2 pb-0 new_package">
        <div className="card p-4 border-0">
          {loading?<p className="text-center my-auto text-sm">Loading...</p>:
           <form onSubmit={addVoucherColors}>
           <div className="row colors_selection">
             <div className="col-md-12 my-1">
               <label>Table Background Color</label>
               <ColorPicker
                 className="color_input"
                 value={colors.table_bg_color}
                 inputType="input"
                //  key={colors.table_bg_color}
                 onChange={(color) =>
                   handleColorChange("table_bg_color", color)
                 }
               />
             </div>
             <div className="col-md-12 my-1">
               <label>Table Header Background</label>
               <ColorPicker
                 className="color_input"
                 value={colors.thead_bg_color}
                //  key={colors.thead_bg_color}

                 inputType="input"
                 onChange={(color) =>
                   handleColorChange("thead_bg_color", color)
                 }
               />
             </div>
             <div className="col-md-12 my-1">
               <label>Heading Color</label>
               <ColorPicker
                 className="color_input"
                //  key={colors.header_color}
               
                 value={colors.header_color}
                 inputType="input"
                 onChange={(color) => handleColorChange("header_color", color)}
               />
             </div>
             <div className="col-md-12 my-1 text-end">
               <button
                 className="btn save_color"
                 type="submit"
                 disabled={isLoading}
               >
                 {isLoading ? "Saving..." : "Save"}
               </button>
             </div>
           </div>
         </form>
          }
         
        </div>
      </div>

      <div className="col-md-8 p-2 pb-0">
        <div className="card p-4 border-0" style={{ overflowX: "auto" }}>
          {/* Preview Container */}
          <div
            className="container-fluid mb-1 bg-white"
            style={{ minWidth: "800px" }}
          >
            {/* Header Section */}
            <div
              className="row align-items-center mb-1 p-0"
              style={{
                borderBottom: `1px solid ${colors.thead_bg_color}`,
              }}
            >
              <div className="col-3 text-start pt-0 mt-0">
                <div
                  className="border py-2 px-3 rounded mt-0"
                  style={{
                    borderColor: colors.thead_bg_color,
                  }}
                >
                  <div className="d-flex justify-content-between">
                    <span style={{ color: "#6D76A1", fontSize: "10px" }}>
                      Voucher number
                    </span>
                    <strong style={{ fontSize: "11px" }}>78688</strong>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span style={{ color: "#6D76A1", fontSize: "10px" }}>
                      Created date
                    </span>
                    <strong style={{ fontSize: "11px" }}>
                      {new Date().toLocaleDateString()}
                    </strong>
                  </div>
                </div>
              </div>

              <div className="col-6 text-center pt-0">
                <img
                  src={profile?.profile_pic}
                  alt="Agency Logo"
                  style={{
                    width: "55px",
                    height: "55px",
                    borderRadius: "10px",
                    objectFit: "cover",
                    marginBottom: "5px",
                  }}
                />
                <h4
                  style={{
                    color: colors.header_color,
                    fontSize: "16px",
                    fontWeight: "600",
                    padding: "0",
                  }}
                >
                  {profile?.name?.length > 30
                    ? `${profile?.name.slice(0, 30)}...`
                    : profile?.name}
                </h4>
                <small
                  style={{
                    color: "#6D76A1",
                    fontSize: "12px",
                    display: "block",
                  }}
                >
                  {profile?.address?.length > 30
                    ? `${profile?.address.slice(0, 30)}...`
                    : profile?.address}
                </small>
                <small style={{ color: "#6D76A1", fontSize: "12px" }}>
                  {profile?.phone?.length > 25
                    ? `${profile?.phone.slice(0, 25)}...`
                    : profile?.phone}
                </small>
              </div>

              <div
                className="col-3 text-start border py-2 px-3 rounded mt-0"
                style={{
                  borderColor: colors.thead_bg_color,
                }}
              >
                <div className="d-flex justify-content-between">
                  <div>
                    <span style={{ color: "#6D76A1", fontSize: "10px" }}>
                      Shirka
                    </span>
                    <br />
                    <strong style={{ fontSize: "11px" }}>ABC</strong>
                  </div>
                  <div>
                    <div style={{ height: "40px", width: "40px" }}>
                      <img
                        src={shiraka_dummy_logo}
                        alt=""
                        style={{
                          height: "100%",
                          width: "100%",
                          borderRadius: "10px",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Main Content Section */}
            <div className="row pt-1 pb-2 px-3">
              {/* General Information Table */}
              <div className="col-12 py-0 my-1">
                <div className="table-responsive py-0 my-0">
                  <table
                    className="table py-0 my-0"
                    style={{
                      borderCollapse: "separate",
                      borderRadius: "5px",
                      overflow: "hidden",
                    }}
                  >
                    <thead
                      style={{
                        backgroundColor: colors.table_bg_color,
                        border: `1px solid ${colors.table_bg_color}`,
                      }}
                    >
                      <tr>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textTransform: "capitalize",
                          }}
                          colSpan={6}
                        >
                          <strong>General Information About Service</strong>
                        </th>
                      </tr>
                    </thead>
                    <thead
                      style={{
                        backgroundColor: colors.thead_bg_color,
                        border: `1px solid ${colors.thead_bg_color}`,
                      }}
                    >
                      <tr>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Adult
                        </th>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Children
                        </th>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Infants
                        </th>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Departure Date
                        </th>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Arrival Date
                        </th>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Nights
                        </th>
                      </tr>
                    </thead>
                    <tbody
                      style={{
                        border: `0.6px solid ${colors.thead_bg_color}`,
                      }}
                    >
                      <tr
                        style={{
                          border: `0.6px solid ${colors.thead_bg_color}`,
                        }}
                      >
                        <td
                          style={{
                            padding: "1.4px",
                            fontSize: "8px",
                            textAlign: "center",
                          }}
                        >
                          2
                        </td>
                        <td
                          style={{
                            padding: "1.4px",
                            fontSize: "8px",
                            textAlign: "center",
                          }}
                        >
                          1
                        </td>
                        <td
                          style={{
                            padding: "1.4px",
                            fontSize: "8px",
                            textAlign: "center",
                          }}
                        >
                          1
                        </td>
                        <td
                          style={{
                            padding: "1.4px",
                            fontSize: "8px",
                            textAlign: "center",
                          }}
                        >
                          01-01-2025
                        </td>
                        <td
                          style={{
                            padding: "1.4px",
                            fontSize: "8px",
                            textAlign: "center",
                          }}
                        >
                          10-01-2025
                        </td>
                        <td
                          style={{
                            padding: "1.4px",
                            fontSize: "8px",
                            textAlign: "center",
                          }}
                        >
                          9
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Flight Details Table */}
              <div className="col-12 py-0 my-1">
                <div className="table-responsive py-0 my-0">
                  <table
                    className="table py-0 my-0"
                    style={{
                      borderCollapse: "separate",
                      borderRadius: "5px",
                      overflow: "hidden",
                    }}
                  >
                    <thead
                      style={{
                        backgroundColor: colors.table_bg_color,
                        border: `1px solid ${colors.table_bg_color}`,
                      }}
                    >
                      <tr>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textTransform: "capitalize",
                          }}
                          colSpan={7}
                        >
                          <strong>Departure Flight</strong>
                        </th>
                      </tr>
                    </thead>
                    <thead
                      style={{
                        backgroundColor: colors.thead_bg_color,
                        border: `1px solid ${colors.thead_bg_color}`,
                      }}
                    >
                      <tr>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Airport
                        </th>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Flight No
                        </th>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Flight Class
                        </th>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Dep Date
                        </th>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Dep Time
                        </th>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Arrival Date
                        </th>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Arrival Time
                        </th>
                      </tr>
                    </thead>
                    <tbody
                      style={{
                        border: `0.6px solid ${colors.thead_bg_color}`,
                      }}
                    >
                      <tr
                        style={{
                          border: `0.6px solid ${colors.thead_bg_color}`,
                        }}
                      >
                        <td
                          style={{
                            padding: "1.4px",
                            fontSize: "8px",
                            textAlign: "center",
                          }}
                        >
                          Jeddah
                        </td>
                        <td
                          style={{
                            padding: "1.4px",
                            fontSize: "8px",
                            textAlign: "center",
                          }}
                        >
                          SV1234
                        </td>
                        <td
                          style={{
                            padding: "1.4px",
                            fontSize: "8px",
                            textAlign: "center",
                          }}
                        >
                          Economy
                        </td>
                        <td
                          style={{
                            padding: "1.4px",
                            fontSize: "8px",
                            textAlign: "center",
                          }}
                        >
                          01-01-2025
                        </td>
                        <td
                          style={{
                            padding: "1.4px",
                            fontSize: "8px",
                            textAlign: "center",
                          }}
                        >
                          10:00 AM
                        </td>
                        <td
                          style={{
                            padding: "1.4px",
                            fontSize: "8px",
                            textAlign: "center",
                          }}
                        >
                          01-01-2025
                        </td>
                        <td
                          style={{
                            padding: "1.4px",
                            fontSize: "8px",
                            textAlign: "center",
                          }}
                        >
                          12:00 PM
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Return Flight Details Table */}
              <div className="col-12 py-0 my-1">
                <div className="table-responsive py-0 my-0">
                  <table
                    className="table py-0 my-0"
                    style={{
                      borderCollapse: "separate",
                      borderRadius: "5px",
                      overflow: "hidden",
                    }}
                  >
                    <thead
                      style={{
                        backgroundColor: colors.table_bg_color,
                        border: `1px solid ${colors.table_bg_color}`,
                      }}
                    >
                      <tr>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textTransform: "capitalize",
                          }}
                          colSpan={7}
                        >
                          <strong>Return Flight</strong>
                        </th>
                      </tr>
                    </thead>
                    <thead
                      style={{
                        backgroundColor: colors.thead_bg_color,
                        border: `1px solid ${colors.thead_bg_color}`,
                      }}
                    >
                      <tr>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Airport
                        </th>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Flight No
                        </th>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Flight Class
                        </th>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Dep Date
                        </th>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Dep Time
                        </th>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Arrival Date
                        </th>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Arrival Time
                        </th>
                      </tr>
                    </thead>
                    <tbody
                      style={{
                        border: `0.6px solid ${colors.thead_bg_color}`,
                      }}
                    >
                      <tr
                        style={{
                          border: `0.6px solid ${colors.thead_bg_color}`,
                        }}
                      >
                        <td
                          style={{
                            padding: "1.4px",
                            fontSize: "8px",
                            textAlign: "center",
                          }}
                        >
                          Madinah
                        </td>
                        <td
                          style={{
                            padding: "1.4px",
                            fontSize: "8px",
                            textAlign: "center",
                          }}
                        >
                          SV5678
                        </td>
                        <td
                          style={{
                            padding: "1.4px",
                            fontSize: "8px",
                            textAlign: "center",
                          }}
                        >
                          Economy
                        </td>
                        <td
                          style={{
                            padding: "1.4px",
                            fontSize: "8px",
                            textAlign: "center",
                          }}
                        >
                          10-01-2025
                        </td>
                        <td
                          style={{
                            padding: "1.4px",
                            fontSize: "8px",
                            textAlign: "center",
                          }}
                        >
                          10:00 AM
                        </td>
                        <td
                          style={{
                            padding: "1.4px",
                            fontSize: "8px",
                            textAlign: "center",
                          }}
                        >
                          10-01-2025
                        </td>
                        <td
                          style={{
                            padding: "1.4px",
                            fontSize: "8px",
                            textAlign: "center",
                          }}
                        >
                          12:00 PM
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Accommodation Details Table */}
              <div className="col-12 py-0 my-1">
                <div className="table-responsive py-0 my-0">
                  <table
                    className="table py-0 my-0"
                    style={{
                      borderCollapse: "separate",
                      borderRadius: "5px",
                      overflow: "hidden",
                    }}
                  >
                    <thead
                      style={{
                        backgroundColor: colors.table_bg_color,
                        border: `1px solid ${colors.table_bg_color}`,
                      }}
                    >
                      <tr>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textTransform: "capitalize",
                          }}
                          colSpan={6}
                        >
                          <strong>Accommodation Detail</strong>
                        </th>
                      </tr>
                    </thead>
                    <thead
                      style={{
                        backgroundColor: colors.thead_bg_color,
                        border: `1px solid ${colors.thead_bg_color}`,
                      }}
                    >
                      <tr>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          City
                        </th>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Hotel
                        </th>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Check in
                        </th>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Check out
                        </th>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Room type
                        </th>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Nights
                        </th>
                      </tr>
                    </thead>
                    <tbody
                      style={{
                        border: `0.6px solid ${colors.thead_bg_color}`,
                      }}
                    >
                      {previewAccommodation.map((accom, index) => (
                        <tr
                          key={index}
                          style={{
                            border: `0.6px solid ${colors.thead_bg_color}`,
                          }}
                        >
                          <td
                            style={{
                              padding: "1.4px",
                              fontSize: "8px",
                              textAlign: "center",
                            }}
                          >
                            {accom.hotel_city}
                          </td>
                          <td
                            style={{
                              padding: "1.4px",
                              fontSize: "8px",
                              textAlign: "center",
                            }}
                          >
                            {accom.hotel_name}
                          </td>
                          <td
                            style={{
                              padding: "1.4px",
                              fontSize: "8px",
                              textAlign: "center",
                            }}
                          >
                            {accom.check_in_date}
                          </td>
                          <td
                            style={{
                              padding: "1.4px",
                              fontSize: "8px",
                              textAlign: "center",
                            }}
                          >
                            {accom.check_out_date}
                          </td>
                          <td
                            style={{
                              padding: "1.4px",
                              fontSize: "8px",
                              textAlign: "center",
                            }}
                          >
                            Double
                          </td>
                          <td
                            style={{
                              padding: "1.4px",
                              fontSize: "8px",
                              textAlign: "center",
                            }}
                          >
                            {accom.hotel_duration}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Transportation Details Table */}
              <div className="col-12 py-0 my-1">
                <div className="table-responsive py-0 my-0">
                  <table
                    className="table py-0 my-0"
                    style={{
                      borderCollapse: "separate",
                      borderRadius: "5px",
                      overflow: "hidden",
                    }}
                  >
                    <thead
                      style={{
                        backgroundColor: colors.table_bg_color,
                        border: `1px solid ${colors.table_bg_color}`,
                      }}
                    >
                      <tr>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textTransform: "capitalize",
                          }}
                          colSpan={3}
                        >
                          <strong>Transportation Details</strong>
                        </th>
                      </tr>
                    </thead>
                    <thead
                      style={{
                        backgroundColor: colors.thead_bg_color,
                        border: `1px solid ${colors.thead_bg_color}`,
                      }}
                    >
                      <tr>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Transport
                        </th>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Transport Services For
                        </th>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Ziyarat
                        </th>
                      </tr>
                    </thead>
                    <tbody
                      style={{
                        border: `0.6px solid ${colors.thead_bg_color}`,
                      }}
                    >
                      <tr
                        style={{
                          border: `0.6px solid ${colors.thead_bg_color}`,
                        }}
                      >
                        <td
                          style={{
                            padding: "1.4px",
                            fontSize: "8px",
                            textAlign: "center",
                          }}
                        >
                          Bus
                        </td>
                        <td
                          style={{
                            padding: "1.4px",
                            fontSize: "8px",
                            textAlign: "center",
                          }}
                        >
                          Airport Transfers
                        </td>
                        <td
                          style={{
                            padding: "1.4px",
                            fontSize: "8px",
                            textAlign: "center",
                          }}
                        >
                          Included
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Pilgrims Details Table */}
              <div className="col-12 py-0 my-1">
                <div className="table-responsive py-0 my-0">
                  <table
                    className="table py-0 my-0"
                    style={{
                      borderCollapse: "separate",
                      borderRadius: "5px",
                      overflow: "hidden",
                    }}
                  >
                    <thead
                      style={{
                        backgroundColor: colors.table_bg_color,
                        border: `1px solid ${colors.table_bg_color}`,
                      }}
                    >
                      <tr>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textTransform: "capitalize",
                          }}
                          colSpan={8}
                        >
                          <strong>Mutamer's (Pilgrims) Details</strong>
                        </th>
                      </tr>
                    </thead>
                    <thead
                      style={{
                        backgroundColor: colors.thead_bg_color,
                        border: `1px solid ${colors.thead_bg_color}`,
                      }}
                    >
                      <tr>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Pilgrim name
                        </th>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Passport No
                        </th>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          DOB
                        </th>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Age Group
                        </th>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Visa no
                        </th>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Issue date
                        </th>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Group code
                        </th>
                        <th
                          style={{
                            padding: "1.5px",
                            fontSize: "9px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Mofa Date
                        </th>
                      </tr>
                    </thead>
                    <tbody
                      style={{
                        border: `0.6px solid ${colors.thead_bg_color}`,
                      }}
                    >
                      {previewMembers.map((member, index) => (
                        <tr
                          key={index}
                          style={{
                            border: `0.6px solid ${colors.thead_bg_color}`,
                          }}
                        >
                          <td
                            style={{
                              padding: "1.4px",
                              fontSize: "8px",
                              textAlign: "center",
                            }}
                          >
                            {member.name}
                          </td>
                          <td
                            style={{
                              padding: "1.4px",
                              fontSize: "8px",
                              textAlign: "center",
                            }}
                          >
                            {member.ppNo}
                          </td>
                          <td
                            style={{
                              padding: "1.4px",
                              fontSize: "8px",
                              textAlign: "center",
                            }}
                          >
                            {member.dob}
                          </td>
                          <td
                            style={{
                              padding: "1.4px",
                              fontSize: "8px",
                              textAlign: "center",
                            }}
                          >
                            {member.age_group}
                          </td>
                          <td
                            style={{
                              padding: "1.4px",
                              fontSize: "8px",
                              textAlign: "center",
                            }}
                          >
                            {member.visa_number || "N/A"}
                          </td>
                          <td
                            style={{
                              padding: "1.4px",
                              fontSize: "8px",
                              textAlign: "center",
                            }}
                          >
                            {member.visa_issue_date || "N/A"}
                          </td>
                          <td
                            style={{
                              padding: "1.4px",
                              fontSize: "8px",
                              textAlign: "center",
                            }}
                          >
                            YU7856
                          </td>
                          <td
                            style={{
                              padding: "1.4px",
                              fontSize: "8px",
                              textAlign: "center",
                            }}
                          >
                            {member.mofa_date || "N/A"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Instructions Section */}
              {/* Instructions Section */}
                <div className={`col-9 mt-1 py-0 ${instructions?.isUrdu ? 'order-2 text-end' : 'order-1 text-start'}`}>
                  <div 
                    className="px-2 border pt-2 pb-3"
                    style={{
                      borderRadius: "4px",
                      borderColor: colors.thead_bg_color,
                    }}
                  >
                    <h6 
                      className={instructions?.isUrdu ? 'text-end urdu_font mb-3' : 'text-start english_font mb-2'}
                      style={{
                        color: colors.header_color,
                        fontSize: "13px",
                        fontWeight: "600",
                      }}
                    >
                      {instructions?.isUrdu ? 'اہم ہدایات' : 'Instructions'}
                    </h6>
                    
                    {(!instructions || !instructions.content?.trim() || instructions.content.trim() === '<p><br></p>') ? (
                      <p style={{ fontSize: "8px" }}>
                        During Hajj or Umrah, pilgrims should first ensure they are in a state of Ihram, 
                        which involves wearing specific garments and making the intention to perform the pilgrimage. 
                        Upon arrival in Makkah, the first step is to perform Tawaf, circling the Kaaba seven times 
                        in a counterclockwise direction. After Tawaf, pilgrims should perform Sa'i, walking seven 
                        times between the hills of Safa and Marwah.
                      </p>
                    ) : (
                      instructions.isUrdu ? (
                        <div 
                          className="urdu_font" 
                          style={{ fontSize: "8px", lineHeight: "1.2" }}
                          dangerouslySetInnerHTML={{ __html: instructions.content }}
                        />
                      ) : (
                        <div 
                          className="english_font" 
                          style={{ fontSize: "8px" }}
                          dangerouslySetInnerHTML={{ __html: instructions.content }}
                        />
                      )
                    )}
                  </div>
                </div>

              {/* Contact Section */}
              <div className={`col-3 mt-1 py-0 ${instructions?.isUrdu ? 'order-1 text-end' : 'order-2 text-start'}`}>
                <div
                  className="p-2 border"
                  style={{
                    borderRadius: "4px",
                    borderColor: colors.thead_bg_color,
                  }}
                >
                   <h6 
                      className={instructions?.isUrdu ? 'text-end urdu_font mb-3' : 'text-start english_font mb-2'}
                      style={{
                        color: colors.header_color,
                        fontSize: "13px",
                        fontWeight: "600",
                      }}
                    >
                      {instructions?.isUrdu ? 'رابطہ کی تفصیلات' : 'Contact'}
                    </h6>
                 
                  {profile?.focal_persons?.map((person, index) => (
                    <div
                      key={index}
                      className="d-flex justify-content-between"
                      style={{ marginBottom: "5px" }}
                    >
                      <strong style={{ fontSize: "10px" }}>
                        {person.city} / {person.name}
                      </strong>
                      <p style={{ fontSize: "10px", margin: 0 }}>
                        {person.phone}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Footer */}
            <div
              style={{
                padding: "5px 10px",
                backgroundColor: "black",
                borderRadius: "4px",
                marginTop: "10px",
              }}
            >
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <i
                    className="fa-brands fa-linkedin"
                    style={{ color: "#CF9137", margin: "0 3px" }}
                  ></i>
                  <i
                    className="fa-brands fa-square-facebook"
                    style={{ color: "#CF9137", margin: "0 3px" }}
                  ></i>
                  <i
                    className="fa-brands fa-instagram"
                    style={{ color: "#CF9137", margin: "0 3px" }}
                  ></i>
                  <span
                    style={{
                      color: "#CF9137",
                      fontSize: "12px",
                      marginLeft: "5px",
                    }}
                  >
                    @Gohijaz
                  </span>
                </div>
                <div>
                  <img
                    src="https://via.placeholder.com/40"
                    alt=""
                    style={{ height: "20px" }}
                  />
                </div>
                <div>
                  <i
                    className="fa-brands fa-edge"
                    style={{ color: "#CF9137" }}
                  ></i>
                  <span
                    style={{
                      color: "#CF9137",
                      fontSize: "12px",
                      marginLeft: "5px",
                    }}
                  >
                    www.gohijaz.com
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}